import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { Environment } from "../Infra/Environment";
const env = new Environment();
if (env.ENABLE_INSTRUMENTATION === "true") {
    const _agent = new BrowserAgent({
        init: {
            distributed_tracing: {
                enabled: true,
                cors_use_newrelic_header: false,
                cors_use_tracecontext_headers: true,
            },
            privacy: { cookies_enabled: true },
            ajax: {
                deny_list: ["bam.nr-data.net", "amazonaws.com"],
            },
            logging: { enabled: true },
            session_replay: { enabled: false },
            obfuscate: [
                {
                    regex: /Bearer\s+[A-Za-z0-9\-._~+/]+=*/g,
                    replacement: "Bearer [REDACTED]",
                },
            ],
        },
        info: {
            beacon: "bam.nr-data.net",
            errorBeacon: "bam.nr-data.net",
            licenseKey: env.NEW_RELIC_BROWSER_LICENSE_KEY,
            applicationID: env.NEW_RELIC_BROWSER_APP_ID,
            sa: 1,
        },
    });
    if (typeof (newrelic === null || newrelic === void 0 ? void 0 : newrelic.setCustomAttribute) === "function") {
        newrelic.setCustomAttribute("service.name", env.NEW_RELIC_SERVICE_NAME);
    }
}
